import React, { useEffect, useMemo } from 'react';
import NumberFormat from 'react-number-format';
import { NavLink } from 'react-router-dom';
import PropTypes from 'prop-types';

import './styles.css';
import LoadMask from '../../../../components/LoadMask';
import PagePagination from '../../../../components/PagePagination';
import ENDPOINT from '../../../../constants/endpoints';
import POPUP_STYLES from '../../../../constants/popup-styles';
import ROUTE from '../../../../constants/route';
import {useGrid} from '../../../../hooks/useGrid';
import BasicDialog from '../../../Dialog/components/BasicDialog';
import FormDialog from '../../../Dialog/components/FormDialog';
import ResponseErrorDialog from '../../../Dialog/components/ResponseErrorDialog';
import SendMessageForm from '../../../Form/components/SendMessageForm';
import ConnectionsItem from './components/ConnectionsItem';

const Connections = props => {
  const { user, id } = props;

  const isOwnConnections = !id;

  const { data, actions } = useGrid(
    isOwnConnections
      ? ENDPOINT.COLLECTION.PEOPLE_CONN
      : ENDPOINT.COLLECTION.CANDIDATE_PROFILE_CONNECTIONS,
    null,
    false
  );

  useEffect(() => {
    actions.fetch(isOwnConnections ? null : { candidateId: id });
  }, []);

  const handleChangeStatus = (person, status) => {
    const index = data.rows.findIndex(
      row => person.ConnectedID === row.ConnectedID
    );
    if (index !== -1) {
      actions.setDataRowByIndex(
        {
          ...data.rows[index],
          ConnectStatus: status,
        },
        index
      );
    }
  };

  const handleSendMessage = (recipients, to) => {
    FormDialog({
      title: `Message to ${to}`,
      modeless: false,
      compact: true,
      popupStyles: { padding: '0', maxWidth: '800px' },
      popupInnerStyles: { padding: '0 30px' },
      params: { recipients },
      form: (actions, params) => (
        <SendMessageForm actions={actions} params={params} />
      ),
    }).then(
      message =>
        BasicDialog({
          bodyRender: message,
          bodyStyles: POPUP_STYLES.warningBodyStyles,
          popupStyles: POPUP_STYLES.warningPopupStyles,
          popupInnerStyles: POPUP_STYLES.warningContentStyles,
          withoutButtons: true,
        }),
      response => ResponseErrorDialog({ response })
    );
  };

  const records = useMemo(
    () =>
      data.rows.map(person => (
        <ConnectionsItem
          user={user}
          key={person.ConnectedID}
          person={person}
          onChangeStatus={isOwnConnections ? null : handleChangeStatus}
          onSendMessage={handleSendMessage}
        />
      )),
    [data]
  );

  return !!data.rows.length ? (
    <div className="sidebar__widget">
      {data.isFetching && <LoadMask relative />}
      <h3 className="connections-block__title">
        {isOwnConnections ? 'Your Connections' : 'Connections'}
        <span className="connections-block__count">
          {' '}
          (
          <NumberFormat
            thousandSeparator
            value={data.rowsCount}
            displayType={'text'}
          />
          )
        </span>{' '}
      </h3>
      {records}
      {isOwnConnections ? (
        <NavLink to={ROUTE.MY_NETWORK} className="connections-block__view-more">
          View More
        </NavLink>
      ) : (
        Number(data.rowsCount) > Number(data.perPage) && (
          <div className="connections-block__pagination">
            <PagePagination
              page={data.page}
              perPage={data.perPage}
              count={data.rowsCount}
              pageRangeDisplayed={3}
              controlFunc={actions.readPage}
              hideFirstLastPages={false}
              hideNavigation={true}
              minimalStyle={true}
              scrollToTop={false}
            />
          </div>
        )
      )}
    </div>
  ) : null;
};

Connections.propTypes = {
  user: PropTypes.object.isRequired,
  id: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
};

export default Connections;
